import * as actions from './actions';
import { ActionType, getType } from 'typesafe-actions';

type Actions = ActionType<typeof actions>;

export const initialState = {};

export default (state = initialState, action: Actions) => {
  switch (action.type) {
    case getType(actions.openModal): {
      return { ...state, [action.payload]: true };
    }
    case getType(actions.closeModal): {
      return { ...state, [action.payload]: false };
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/modal/reducer.ts